import React from 'react';
import { useDropzone } from 'react-dropzone';
import { observer } from 'mobx-react';

import { Button } from 'ui';

interface Props {
  classNames?: (classes: string[]) => string[];
  uploadFile: (file: File) => any;
  size?: React.ComponentProps<typeof Button>['size'];
  children?: React.ComponentProps<typeof Button>['children'];
  error?: boolean;
}

function UploadFileButton({ uploadFile, size, children, classNames = (a) => a, error = false }: Props) {
  const onDrop = (files: File[]) => files.forEach((file: File) => uploadFile(file));
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps({ style: { display: 'inline-block' } })}>
      <input {...getInputProps()} />
      <Button icon="paper-clip" classNames={classNames} size={size}>
        {children}
      </Button>
    </div>
  );
}

export default observer(UploadFileButton);
